export const testimonials = [
	{
		name: 'Kwame Mensah',
		avatar: 'https://randomuser.me/api/portraits/men/10.jpg',
		title: 'Best Decision Ever',
		feedback:
			'ThrughPass has revolutionized how I buy passes. I can trust every purchase, and the peace of mind is priceless.',
	},
	{
		name: 'Ama Agyeman',
		avatar: 'https://randomuser.me/api/portraits/women/45.jpg',
		title: 'Incredible Service',
		feedback:
			"I've attended so many events thanks to ThrughPass. It's reliable, fast, and secure. No more worrying about scams!",
	},
	{
		name: 'Dayo Okonkwo',
		avatar: 'https://randomuser.me/api/portraits/men/85.jpg',
		title: 'Highly Recommended',
		feedback:
			'Buying passes has never been this easy. The seamless checkout experience blew me away!',
	},
	{
		name: 'Tasha Johnson',
		avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
		title: 'Unforgettable Experiences',
		feedback:
			"I've been able to discover amazing events I wouldn't have known about. ThrughPass is the real deal!",
	},
	{
		name: 'Malik Abubakar',
		avatar: 'https://randomuser.me/api/portraits/men/64.jpg',
		title: 'Game-Changer',
		feedback:
			"As someone who attends events regularly, ThrughPass has made my life so much easier. I can't recommend it enough!",
	},
	{
		name: 'Nia Parker',
		avatar: 'https://randomuser.me/api/portraits/women/52.jpg',
		title: 'Secure and Easy',
		feedback:
			"It's refreshing to have a platform that puts security first. ThrughPass ensures my passes are authentic every time.",
	},
	{
		name: 'Abena Adomako',
		avatar: 'https://randomuser.me/api/portraits/women/25.jpg',
		title: 'Perfect for Families',
		feedback:
			"I've used ThrughPass to plan family outings, and it's been so convenient. We love how easy it is to use!",
	},
	{
		name: 'Jamal Carter',
		avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
		title: 'Trusted Platform',
		feedback:
			"I don't have to worry about fake passes anymore. ThrughPass is my go-to for events big and small!",
	},
	{
		name: 'Aisha Mahama',
		avatar: 'https://randomuser.me/api/portraits/women/84.jpg',
		title: 'Amazing Selection',
		feedback:
			'The range of events available on ThrughPass is unmatched. I always find something new and exciting.',
	},
	{
		name: 'Kojo Antwi',
		avatar: 'https://randomuser.me/api/portraits/men/19.jpg',
		title: 'Smooth and Simple',
		feedback:
			'The process from browsing to checkout is so smooth. ThrughPass makes event planning effortless!',
	},
];
